<template>
    <div class="wrapper" id="share_transfer" style="min-width: 1000px;width:100%;height: 100%;max-height: 100%;overflow: auto;">
        <div id="leftBan"></div><!-- 用户弹窗的提示语 -->
        <div class="sf-logo"><div class="logo-transfer"></div><div v-html="$t('language.shareTransfers.logoMsg')"></div></div>
        <rightContBan ref="rightContBan"></rightContBan>
        
        <div class="share_page_boby all-loadPage" v-show="initLoading">
            <div class="img-loading">
                <img src="../assets/images/loading.gif">
                <div class="load-size"><b>{{$t('language.common.load')}}<span class="dotting"></span></b></div>
            </div>
        </div>
        <!-- 中央工作区 -->
        <div id="share_transfer_body" class="share-transfer-buttom center">
            <div id='check_share' v-loading="isLoading">
                <div class="share-transfer-body">
                    <!-- 选择列表区 -->
                    <div class="share-transfer-items" id="sfFilesItems" v-show="selectItemArr.length>0&&shareTransferState=='check'">
                        <el-scrollbar style='height:100%;' ref="scrollbar">
                        <div class="share-transfer-files">
                            <div class="share-transfer-item file-item" v-for="(item,index) in selectItemArr" :key="index">
                                <div class="share-title" :title="item.name">{{item.name}}</div>
                                <span v-if="item.size">{{item.size|formatByte}}</span>
                                <span v-else>{{$t('language.shareTransfers.folder')}}</span>
                                <div class="icon-close" @click.stop="deleteSelectFiles(index,item.keyId)"></div>
                            </div>
                        </div>
                        <!-- 固定底部 -->
                        <div class="share-transfer-options" :class="selectItemArr.length<4?'bottom':''">
                            <div class="share-transfer-item add-transfer-item" @click="transferSourceDialogShow()">
                                <div class="icon-add-hover"></div>
                                <div class="icon-add"></div>
                                <div>
                                    <div>{{$t('language.shareTransfers.addFiles')}}</div>
                                    <span>{{$t('language.shareTransfers.addFileTip',{"num":this.selectItemArr.length})}}</span>
                                </div>
                            </div>
                            <div class="share-transfer-item share-transfer-option" @click="checkOption('shareTitle')">
                                <span :style="checkTitle?'font-size:12px;':''">{{$t('language.shareTransfers.transferTitle')}}</span>
                                <div>
                                    <input type="text" name="title" id="shareTitle" v-model="transferInfoTitle" 
                                    class="name-edit-input" autocomplete="Off" :maxLength="129" @input="writeTextCheck('title')"
                                    @focus="checkTitle=true" @blur="checkTitle=false" />
                                </div>
                            </div>
                            <hr color=#eff5fd size=1>
                            <div class="share-transfer-item share-transfer-option" @click="checkOption('shareDescription')">
                                <span :style="checkDes?'font-size:12px;':''">{{$t('language.shareTransfers.transferDescription')}}</span>
                                <div>
                                    <textarea rows="1" type="text" name="description" id="shareDescription" ref="shareDescription" 
                                    v-model="transferInfoDescription" autocomplete="Off" :maxLength="513" @input="writeTextCheck('description')" onkeydown="if(event.keyCode==13)return false;"
                                    @focus="checkDes=true" @blur="checkDes=false" />
                                </div>
                            </div>
                        </div>
                        </el-scrollbar>
                    </div>
                    <!-- Add按钮区 -->
                    <div class="share-transfer-items center" id="sfAddItems" v-if="selectItemArr.length==0&&shareTransferState=='check'" @click="transferSourceDialogShow()">
                        <div class="share-transfer-add" >
                            <div class="icon-add-hover"></div>
                            <div class="icon-add"></div>
                            <span>{{$t('language.shareTransfers.addFiles')}}</span>
                        </div>
                    </div>
                    <!-- 进度条区 -->
                    <div class="share-transfer-items center" id="sfProgressBar" v-if="shareTransferState=='transfering'||shareTransferState=='canceling'">
                        <div>
                            <div style="width:200px;height:200px;">
                                <svg-line :rate="progressNum" bg-ring-color="#EBEBEC" :stroke-width="24" :part="1" :part-gap="0" :show-gradient="true" ></svg-line>
                            </div>
                            <div class="sf-transfer-msgs" v-if="shareTransferState=='transfering'">
                                <div class="sf-transfer-msg">{{$t('language.shareTransfers.trnsfering')}}</div>
                                <div class="sf-transfer-num">{{$t('language.shareTransfers.sendingFile',{"num":this.selectItemArr.length})}}</div>
                                <!-- <div class="sf-transfer-size">{{$t('language.shareTransfers.sendingFile',getSendingSize())}}</div> -->
                                <div class="sf-transfer-size">{{$t('language.shareTransfers.sendingTip')}}</div>
                            </div>
                            <div class="sf-transfer-msgs" v-if="shareTransferState=='canceling'">
                                <div class="sf-transfer-msg">{{$t('language.shareTransfers.cancelTransfer')}}</div>
                            </div>
                        </div>
                    </div>
                    <!-- 创建成功 -->
                    <div class="share-transfer-items center" id="sfExistence" v-if="shareTransferState=='existence'">
                        <div class="share-back center" @click="backNewTransfer()">
                            <div class="icon-util arrow-left-blue"></div>
                            <span>{{$t('language.cloudExploer.back')}}</span>
                        </div>
                        <div>
                            <img :src="GIF"/>
                            <div class="sf-transfer-msgs">
                                <div class="sf-transfer-msg">{{$t('language.shareTransfers.createdTransfer')}}</div>
                            </div>
                        </div>
                    </div>
                    <!-- 功能区 -->
                    <div class="share-transfer-fun center" id="share_buttons">
                        <!-- <div class="st-fun-items" id="stFunItems" style="display:none;" :class="(stFunItemsShow&&shareTransferState=='check')?'st-fun-items-open':'st-fun-items-close'">
                            <div class="st-fun-item">
                                <span>{{$t('language.shareTransfers.expiresAfter')}}</span>
                                <div id="sfSetExpires">1 weeks</div>
                                <div class="icon-satr"></div>
                            </div>
                            <div class="st-fun-item" style="border-top: solid 1Px #EDEEF0;">
                                <span>{{$t('language.login.password')}}</span><br>
                                <input type="password" v-model="password" :placeholder="'Set password'" name="password" class="password" 
                                    @focus="passwordShow=true" @blur="passwordShow=false" :class="passwordShow?'':'password-disable'"/>
                                <div class="icon-satr"></div>
                            </div>
                        </div>
                        <div class="st-btn-create center" v-if="shareTransferState=='check'">
                            <button @click="createShareTransfer()">{{$t('language.shareTransfers.createShare')}}</button>
                            <button class="st-more" @click="openFunItems()"><div :class="stFunItemsShow?'arrow-down':'bt-point'"></div></button>
                        </div> -->
                        <div class="st-btn-other center" v-if="shareTransferState=='check'">
                            <button @click="createShareTransfer()">{{$t('language.shareTransfers.createShare')}}</button>
                        </div>
                        <div class="st-btn-other center" v-if="shareTransferState=='transfering'">
                            <button @click="shareTransferState='canceling'" class="white-btn">{{$t('language.common.cancel')}}</button>
                        </div>
                        <div class="st-btn-other center" v-if="shareTransferState=='canceling'">
                            <button @click="cancelTransfer()" class="white-btn">{{$t('language.common.yes')}}</button>
                            <button @click="shareTransferState='transfering'">{{$t('language.common.no')}}</button>
                        </div>
                        <div class="st-btn-other center" v-if="shareTransferState=='existence'">
                            <button @click="copySite()" class="white-btn">{{$t('language.common.copyLink')}}</button>
                            <button @click="shareDialgOpen()">{{$t('language.popup.cloudExploerPopup.shareSendEmail')}}</button>
                        </div>
                    </div>
                    <!-- 报错提示，复用请拆解为组件 -->
                    <div class="options-err-info" id="share_title_err" :class="isTitleErr?'':'fadeErr'">
                        <div class="options-err-body center">
                            <div class="icon-mistake"></div>
                            <span>{{$t('language.shareTransfers.titleErrMsg')}}</span>
                        </div>
                    </div>
                    <div class="options-err-info" id="share_des_err" :class="isDesErr?'':'fadeErr'">
                        <div class="options-err-body center">
                            <div class="icon-mistake"></div>
                            <span>{{$t('language.shareTransfers.desErrMsg')}}</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <shareDialog ref="shareDialog" :isTransfer="true"></shareDialog>
        <transferSourceDialog ref="transferSourceDialog"></transferSourceDialog>
        <signInDialog ref="signInDialog"  :isTransfer="true"></signInDialog>
    </div>
</template>
<script>
import rightContBan from '@/components/common/share_right_top_banner';
import commonUtils from "@/js/workspace/common_util.js";
import taskTransferUtils from '@/js/workspace/task_transfer_util.js';
import commonstate from '@/js/constant.js';
import shareDialog from "@/components/popup/cloud_exploer_popups/share_popup";
import transferSourceDialog from "@/components/popup/cloud_transfer_popups/transfer_multi_popup";
import signInDialog from '@/components/popup/share_page_popups/sign_in_popup';

import SvgLine from "@/components/common/progress/annular";

import GIF  from '../assets/images/success.gif';

const BASE_URL = commonstate.sharePageUrl;

export default {
    components:{
      rightContBan,
      shareDialog,
      transferSourceDialog,
      signInDialog,
      SvgLine,
      GIF,
    },
    name: "share_page",
    data:()=>({
        user: commonUtils.getUser(),
        initLoading: false,//加载等待
        sfInfo: {},//分享传输实体
        progressNum: 0.00,//进度
        mulitDrives: [],
        selectItemArr: [],//选中分享传输文件集合
        shareTransferState: 'check',
        stFunItemsShow: false,//是否显示功能按钮区
        passwordShow: false,//是否选择密码栏
        transferInfoTitle: '',//分享标题
        transferInfoDescription:'',//分享简介
        isLoading: false,//是否开启loading状态
        isDefaultTitle: true,//是否默认title为第一个文件名
        isTitleErr: false,//是否打开对应报错提示
        isDesErr: false,//是否打开对应报错提示
        checkTitle: false,//选择输入标题
        checkDes: false,//选择输入简介
    }),
    watch: {
        transferInfoDescription(newValue,oldValue){
            var elem = this.$refs.shareDescription;
            elem.scrollTop = 0; // 防抖动
            if(newValue.length>oldValue.length){
                //进行
                if(elem.scrollHeight>elem.clientHeight){
                    elem.style.height = elem.scrollHeight + "px";
                }
            }else{
                //退行
                elem.style.height = "21px";
                if(elem.scrollHeight>elem.clientHeight){
                    elem.style.height = elem.scrollHeight + "px";
                }
            }
        },
        //错误提示自动关闭
        isTitleErr(newValue,oldValue){
            if(newValue){
                this.handleScroll();
                $('#share_title_err').show();
                setTimeout(()=>{
                    this.isTitleErr = false;
                },5000)
            }
        },
        isDesErr(newValue,oldValue){
            if(newValue){
                this.handleScroll();
                $('#share_des_err').show();
                setTimeout(()=>{
                    this.isDesErr = false;
                },5000)
            }
        },
        mulitDrives(newValue,oldValue){
            let obj1;
            let obj2;
            var selectList = [];
            if(newValue.length<1){
                return;
            }
            //去重合并
            if(this.selectItemArr.length>0){
                for(obj1 of newValue){
                    let flag = true;
                    for(obj2 of this.selectItemArr){
                        if((obj1.id === obj2.id) && (obj1.driveId === obj2.driveId)){
                            flag = false;
                            break;
                        }
                    }
                    if(flag){
                        selectList.push(obj1);
                    }
                }
                if(selectList.length>0){
                    this.selectItemArr = this.selectItemArr.concat(selectList);
                }
            }else{
                this.selectItemArr = newValue;
                //默认名
                if(this.isDefaultTitle){
                    this.transferInfoTitle = this.selectItemArr[0].name;
                }
            }
            //完成后清除选中效果
            newValue = [];
            this.reset();
        }
    },
    mounted() {
        //滚动条监听，复用请拆解为组件形式
        this.$refs.scrollbar.wrap.onscroll = (e) => {
            this.handleScroll();
        }
        if(!commonUtils.getUser()){
            return;
        }else{
            var fileInfo = sessionStorage.getItem("share_transfer");
            if(fileInfo!=null){
                fileInfo = JSON.parse(fileInfo);
                this.selectItemArr.push(fileInfo);
                if(this.isDefaultTitle){
                    //默认名
                    this.transferInfoTitle = fileInfo.name;
                }
                //只获取一次，刷新后不再保留
                sessionStorage.removeItem("share_transfer");
            }
            var shareId = sessionStorage.getItem("share_transfers_id");
            if(shareId){
                this.initShareTransfers(shareId);
            }
        }
        //设置随机gif后缀，防止缓存命中
        this.GIF  = GIF  +'?+' + Math.random();
    },
    methods: {
        //初始化分享传输
        initShareTransfers(id){
            this.isLoading = true;
            var date = {
                id:id,
            }
            this.Utils.doShareRequest("get_share_transfers", date).then(res => {
                this.isLoading = false;
                if(res.share){
                    if(this.user&&res.share.userId==this.user.id){
                        this.sfInfo = res.share;
                        this.shareTransferState = 'existence';
                    }
                }
            })
        },
        //打开功能设置区
        openFunItems(){
            this.$refs.transferSourceDialog.$refs.tree.setChecked(this.selectItemArr[0].id, true);
            if(!this.user){
                //未登录提示登录
                this.openSignInPopup();
                return;
            }
            $("#stFunItems").show();
            this.stFunItemsShow = !this.stFunItemsShow;
        },
        //返回创建一个新的分享传输
        backNewTransfer(){
            this.shareTransferState = 'check';
            this.isDefaultTitle = true;
            this.selectItemArr = [];
            this.transferInfoTitle = '';
            this.transferInfoDescription = '';
            sessionStorage.removeItem("share_transfers_id");
        },
        //创建分享传输
        createShareTransfer(){
            if(!this.user){
                //未登录提示登录
                this.openSignInPopup();
                return;
            }
            if(this.selectItemArr.length<1){
                return;
            }
            //错误提示
            if(this.transferInfoTitle.length>128){
                if(!this.isTitleErr){
                    this.$refs.scrollbar.wrap.scrollTop = this.$refs.scrollbar.wrap.scrollHeight;
                    this.isTitleErr = true;
                }
                return;
            }
            if(this.transferInfoDescription.length>512){
                if(!this.isDesErr){
                    this.$refs.scrollbar.wrap.scrollTop = this.$refs.scrollbar.wrap.scrollHeight;
                    this.isDesErr = true;
                }
                return;
            }

            //创建分享传输任务
            this.shareTransferState = 'transfering';
            //处理数据
            var shareFiles = taskTransferUtils.createTransferFromItems(this.selectItemArr);
            //处理路由
            var path = [];
            shareFiles.forEach(e => {
                if(e.nodes){
                    e.nodes.forEach(n => {
                        if(n.fileId!=e.fileId){
                            let item = {
                                name:n.filename,
                                id:n.fileId,
                                driveId:e.driveId,
                            }
                            path.push(item);
                        }
                    });
                }
                e.nodes = path;
            });

            var title = this.transferInfoTitle;
            if(!title){
                //如果没有title则默认第一个文件名
                title = this.selectItemArr[0].name;
            }

            let date = {
                ud: this.user.id,
                name: title,
                description: this.transferInfoDescription,
                url:`${BASE_URL}`,
                shareFiles: {"cloud":shareFiles},
            }
            // if(this.password){
            //     date.type = 2;
            //     date.password = this.transferInfo.password;
            // }else{
                date.type = 1;
            // }

            this.progressNum = 0;
            //假进度
            this.progressNum = 0.5;
            this.timer = setInterval(() => {
                if(this.progressNum<1){
                    this.progressNum += 0.3;
                }else{
                    clearInterval(this.timer);
                    //如果不是传输状态则不会创建
                    if(this.shareTransferState != 'transfering'){
                        return;
                    }
                    this.Utils.doShareRequest("create_share_transfers_url", date).then(res => {
                        if(res.share){
                            //缓存已创建对象
                            this.sfInfo = res.share;
                            //缓存已创建对象id
                            sessionStorage.setItem("share_transfers_id", this.sfInfo.id);
                            this.shareTransferState = 'existence';
                        }else if(res.status=='400'){
                            this.$toast({
                                text: 'Created Fail',
                                type: "fail",
                                idValue: "share_transfer"
                            });
                        }
                    })
                }
            }, 1000);
        },
        //中止创建分享传输
        cancelTransfer(){
            this.shareTransferState = 'check';
            clearInterval(this.timer);
        },
        //复制链接
        copySite() {
            if (this.sfInfo.url) {
                let copyInput = document.createElement("input");
                copyInput.value = this.sfInfo.url;
                document.body.appendChild(copyInput);
                copyInput.select(); // 选择对象
                document.execCommand("Copy"); // 执行浏览器复制命令
                this.$toast({
                    text: this.$t('language.popup.cloudExploerPopup.linkCopySuccessful'),
                    type: "success",
                    idValue: "share_transfer"
                });
            }
        },
        //打开发送邮件界面
        shareDialgOpen() {
            if(!this.user){
                //未登录提示登录
                this.openSignInPopup();
                return;
            }
            this.$refs.shareDialog.fileInfo = this.sfInfo;
            this.$refs.shareDialog.linkUrl = this.sfInfo.url;
            this.$refs.shareDialog.inviteEmailShow = true;
            this.$refs.shareDialog.foldingPanel = "folding-panel-up";
            this.$refs.shareDialog.shareShow = true;
            
        },
        // 打开源目录弹窗
        transferSourceDialogShow() {
            if(!this.user){
                //未登录提示登录
                this.openSignInPopup();
                return;
            }
            let that = this;
            this.$refs.transferSourceDialog.taskMultiShow = true;
            //获取源弹窗已选中的节点
            let checkedNodes = this.$refs.transferSourceDialog.checkedNodes;
            if (!checkedNodes) {
                checkedNodes = [];
            }
            if(!checkedNodes.length){
                 let div= this.$refs.transferSourceDialog.$refs['elscrollbar'].wrap;//获取滚动条
                this.$forceUpdate();
                this.$nextTick(() => {
                            this.$refs.transferSourceDialog.$refs['elscrollbar'].wrap.scrollTop=0;
                });
            }   
            this.$refs.transferSourceDialog.$refs.tree.setCheckedNodes(checkedNodes);
              //使滚动条回到原来的位置
            this.$nextTick(function () {
                that.$refs.transferSourceDialog.refresh();
            });
            this.$store.commit("setTransferFromOpen", true);
        },
        //删除已选择的文件
        deleteSelectFiles(index,id){
            if(this.selectItemArr.length>index){
                //使用默认名时,如果删除的第一个，需要判断名称是否和title一致，一致需要修改title
                if(index==0&&this.selectItemArr[0].name==this.transferInfoTitle&&this.isDefaultTitle){
                    if(this.selectItemArr[1]){
                        this.transferInfoTitle = this.selectItemArr[1].name;
                    }else{
                        this.transferInfoTitle = "";
                    }
                }
                this.selectItemArr.splice(index, 1);
                //取消该项的选中
                let that = this;
                this.$refs.transferSourceDialog.$refs.tree.setChecked(id, false);
                $.each(this.$refs.transferSourceDialog.checkedNodes, function (nodeIndex, nodeItem) {
                    if (nodeItem.id == id) {
                        that.$refs.transferSourceDialog.checkedNodes.splice(nodeIndex, 1);
                        return false;
                    }
                });
            }
        },
        //获取文件大小进度参数
        getSendingSize(){
            let date = {
                "now":0,
                "all":0,
            }
            this.selectItemArr.forEach(v => {
                if(v.size){
                    date.all += v.size;
                }
            });

            date.all = commonUtils.formatByte(date.all);
            date.now = date.all;
            return date;
        },
        //清除弹窗选中效果
        reset(){
            this.$refs.transferSourceDialog.checkedNodes.forEach(ele=>{ // 把已选中的复选框清除
                this.$nextTick(()=>{
                    this.$refs.transferSourceDialog.$refs.tree.setChecked(ele.keyId,false);
                })
            })
            this.$refs.transferSourceDialog.checkedNodes = [];
        },
        //打开登录窗口
        openSignInPopup(){
            this.$refs.signInDialog.signInShow = true;
            this.$refs.signInDialog.state = "signIn";
            this.$refs.signInDialog.isTransfer = true;
        },
        //获取焦点
        checkOption(type){
            var input = $('#'+type+'');
            if(input.length>0){
                input[0].focus();
            }
        },
        //文本框写入检查
        writeTextCheck(type){
            switch (type) {
                case 'title':
                    if(this.transferInfoTitle!=this.selectItemArr[0].name){
                        //修改名称后，不再使用默认名
                        this.isDefaultTitle = false;
                    }
                    if(this.transferInfoTitle.length>128){
                        this.transferInfoTitle = this.transferInfoTitle.substring(0,128);
                        //触发提示
                        if(!this.isTitleErr){
                            this.isTitleErr = true;
                        }
                    }
                    break;
                case 'description':  
                    if(this.transferInfoDescription.length>512){
                        this.transferInfoDescription = this.transferInfoDescription.substring(0,512);
                        //触发提示
                        if(!this.isDesErr){
                            this.isDesErr = true;
                        }
                    }
                    break;
                default:
                    break;
            }
        },
        //滚动条监听事件,复用请拆解为组件形式
        handleScroll(){
            //仅选择时需要监听
            if(this.shareTransferState != 'check'&&this.selectItemArr.length<1){
                return;
            }
            var allNotice = $('#share_transfer_body').offset();
            var bottomTop =  $('#share_buttons').offset().top - allNotice.top -35;//最低高度
            //标题提示
            var titleNotice = $('#shareTitle').offset();
            if(titleNotice&&allNotice){
                var titleErrTop = titleNotice.top - allNotice.top -15;
                if(titleErrTop>bottomTop){
                    this.isTitleErr = false;
                    titleErrTop = bottomTop;
                }  
                $('#share_title_err').css('top',titleErrTop+"px");
            }
            //内容提示
            var desNotice = $('#shareDescription').offset();
            if(desNotice&&allNotice){
                var desErrTop = desNotice.top - allNotice.top -15;
                if(desErrTop>bottomTop){
                    this.isDesErr = false;
                    desErrTop = bottomTop;
                }  
                $('#share_des_err').css('top',desErrTop+"px");
            }
        },
    }
}
</script>
<style>
#share_transfer {
    background-color: #f2f7fe!important;
    font-family: Microsoft YaHei;
    position: relative;
}

.sf-logo {
    z-index: 100;
    position: absolute;
    display: inline-flex;
    margin: 10px;/*no*/
    font-size: 24px;/*no*/
    font-family: Arial;
    font-weight: bold;
    line-height: 40px;/*no*/
}

.sf-logo .sf-logo-first{
    margin: 0 10px;/*no*/
}

.sf-logo .sf-logo-name{
    color: #5562B4;
}

#check_share {
    margin-bottom: 100px;
    width: 460px;
    height: 560px;
    background-color: #ffffff;
    box-shadow: 0px 10px 20px rgba(48, 50, 54, 0.06);/*no*/
    opacity: 1;
    border-radius: 10px;/*no*/
}

.share-transfer-buttom{
    min-height: 700px;
    width: 100%;
    height: calc(100% - 60px);
    background: url(/static/img/task.ddcdd30.png) no-repeat bottom center;
    background-size: 100% 25%;
}

.share-transfer-body {
    width: 100%;
    height: 100%;
    padding-top: 10px;
}

.share-transfer-items {
    height: calc(100% - 100px);
    font-size: 18px;/*no*/
    font-weight: 400;
    line-height: 24px;/*no*/
    color: #333333;
    position: relative;
}

#sfFilesItems {
    padding-left: 10px;
}

#sfFilesItems .is-vertical{
    margin-right: -3px;/*no*/
}

#sfFilesItems .file-item{
    margin-right: 10px;
}

.share-transfer-items .file-item{
    background-color: #F9FBFE;
    border: 1px solid #EFF5FD;/*no*/
    opacity: 1;
    position: relative;
}

.share-transfer-files {
    min-height: 270px;
}

.share-transfer-item {
    padding: 5px 10px;
    margin-bottom: 5px;
    border-radius: 8px;/*no*/
    min-height: 40px;
}

.share-transfer-item.file-item .share-title {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    width: 90%;
}

.share-transfer-item.file-item span,.share-transfer-options span{
    font-size: 14px;/*no*/
    color: #A6AFBF;
}

.share-transfer-item.file-item:hover{
    border: 1px solid #B3BCF6;/*no*/
}

.share-transfer-options {
    margin-right: 10px;
    width: calc(100% - 10px);
}

.share-transfer-options.bottom {
    position: absolute;
    bottom: 0;
}

.share-transfer-options hr{
    text-align: center;
    width: calc(100% - 20px);
}

.share-transfer-option {
    cursor: text;
}

.share-transfer-option input{
    width: 100%;
}

.add-transfer-item {
    display: inline-flex;
    width: calc(100% - 20px);
    border: 1px solid #EFF5FD;/*no*/
    opacity: 1;
    font-size: 16px;/*no*/
    font-weight: 400;
    line-height: 24px;/*no*/
    color: #6F7886;
    cursor: pointer;
}

/*控制按钮状态*/
.add-transfer-item:hover {
    color: #3250c9;
}

.add-transfer-item .icon-add-hover{
    margin-right: 10px;
    background-repeat: round;
    display: none;
}

.add-transfer-item .icon-add {
    margin-right: 10px;
    background-repeat: round;
}

.add-transfer-item:hover .icon-add{
    display: none;
}

.add-transfer-item:hover .icon-add-hover{
    display: unset;
}

.add-transfer-item div{
    align-self:center;
}

.add-transfer-item span{
    color: #BDBDBD;
}



.share-transfer-fun {
    margin: 0 10px;
    height: 90px;
    border-top: solid 2Px #CDDDF5;
}

.share-transfer-fun button {
    height: 44Px;
    border-radius: 6Px;
    font-size: 16px;/*no*/
    font-weight: 400;
    line-height: 24px;/*no*/
    background-color: #3250C9;
    min-width: 140Px;
    padding: 0 10Px;
}

.share-transfer-fun button:hover {
    background-color: #5065BC;
}

.share-transfer-fun .white-btn {
    background-color: #fff;
    border: 1px solid #5065BC;/*no*/
    color: #5065BC;
}

.share-transfer-fun .white-btn:hover {
    background-color: #fff;
}

.st-btn-create button {
    border-radius: 6Px 0 0 6Px;
}

.st-btn-other button {
    margin: 0 15Px;
}

.share-transfer-fun .st-btn-create button.st-more{
    min-width: 48Px;
    width: 48Px;
    border-radius: 0 6Px 6Px 0;
    border-left: solid 1Px #FFF;
}

.share-transfer-fun button.st-more .bt-point{
    margin: auto;
}

.share-transfer-fun button.st-more .arrow-down {
    margin: auto;
}

.st-fun-items {
    background-color: #fff;
    border-top: solid 2Px #CDDDF5;
    position: absolute;
    height: 100px;
    width: 100%;
    top: - 100px;
    font-size: 15px;/*no*/
    font-weight: 400;
    line-height: 26px;/*no*/
    color: #333333;
}

.st-fun-item {
    position: relative;
    margin: 0 10px;
}

.st-fun-item span {
    color: #6F7886;
}

.st-fun-item .icon-satr {
    position: absolute;
    right: 0;
    top: calc(50% - 13Px);
}

.center {
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
}

#sfAddItems {
    height: calc(100% - 120px);
    margin: 0 10px 10px 10px;
    background-color: #F9FBFE;
    border: 1px solid #EFF5FD;/*no*/
    opacity: 1;
    border-radius: 8px;/*no*/
    cursor: pointer;
}

.share-transfer-add {  
    display: inline-flex;
}

.share-transfer-add span{
    padding-left: 10px;
    line-height: 46Px;
    font-size: 20Px;
    font-weight: 700;
}


.share-transfer-add .icon-add{
    display: unset;
}

.share-transfer-add .icon-add-hover{
    display: none;
}

#sfAddItems:hover {  
    color: #3250c9;
}

#sfAddItems:hover .icon-add-hover{
    display: unset;
}

#sfAddItems:hover .icon-add{
    display: none;
}

.sf-transfer-msgs {
    text-align: center;
    font-family: Arial;
    line-height: 24Px;
    margin-top: 40Px;
    height: 100px;
}

.sf-transfer-msgs .sf-transfer-msg{
    font-size: 18Px;
    font-weight: 700;
    color: #333333;
    margin: 14Px 0;
}

.sf-transfer-msgs .sf-transfer-num{
    font-size: 14Px;
    color: #6F7886;
}

.sf-transfer-msgs .sf-transfer-size{
    font-size: 14Px;
    color: #BDBDBD;
    margin-top: 30Px;
}

#share_transfer .password {
    height: 26Px;
    width: 120Px;
    margin: 0;
    line-height: 26Px;
    font-size: 16Px;
    border: 1Px solid #bbb9c3;
    border-radius: 10Px;
    padding: 0 10Px 0 10Px;
}

#share_transfer .password-disable {
    border: 0Px solid #bbb9c3;
    padding:0;
    cursor: pointer;
}

#share_transfer .arrow-down {
    filter: drop-shadow(#fff 80px 0);/*no*/
    transform: translateX(-80px);/*no*/
}

#share_transfer .icon-close {
    position: absolute;
    right: 20px;/*no*/
    top: 20px;/*no*/
    cursor: pointer;
    display: none;
}

#share_transfer .share-transfer-item:hover .icon-close{
    display: block;
}

#share_transfer .share-transfer-option .name-edit-input{
    width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
    font-family: Microsoft YaHei;
}

#share_transfer .share-transfer-option textarea{
    width: 100%;
    height: auto;
    outline: none;
    resize: none;
    border: none!important;
    overflow: hidden;
    color: #6f7886;
    font-family: Microsoft YaHei;
}

#share_transfer .options-err-body{
    position: relative;
    width: 256px;/*no*/
    height: 70px;/*no*/
    background: #667180;
    box-shadow: 0px 8px 10px rgba(48, 50, 54, 0.06);/*no*/
    border-radius: 10px;/*no*/
}

#share_transfer .options-err-body::before{
    content: '';
    position: absolute;
    border: 13px solid;/*no*/
    border-color: transparent #667180 transparent transparent;
    left: -26px;/*no*/
    top: 20px;/*no*/
}

#share_transfer .options-err-body span {
    padding-right: 16px;/*no*/
    width: 170px;/*no*/
    font-size: 14px;/*no*/
    font-family: Arial;
    font-weight: 400;
    line-height: 16px;/*no*/
    color: #ffffff;
}

#share_transfer .icon-mistake {
    margin: 16px;/*no*/
}

#share_transfer .share-back{
    position: absolute;
    color: #2E79F6;
    top: 5px;
    left: 10px;
    font-size: 14px;/*no*/
    cursor: pointer;
}

#share_transfer .share-back:hover{
    color: #3250C9;
}

#share_transfer .arrow-left-blue {
    background-position: -468px -204px;/*no*/
}

/* 动画效果 */
.st-fun-items-open {
    animation: openFun 0.5s 1 alternate both;
    overflow: hidden;
    transform-origin:bottom;
}

.st-fun-items-close {
    animation: closeFun 0.5s 1 alternate both;
    overflow: hidden;
    transform-origin:bottom;
}

@keyframes closeFun {
    0% {
        transform: scaleY(1);
    }

    100% {
        transform: scaleY(0);
    }
}

@-webkit-keyframes closeFun {
    0% {
        transform: scaleY(1);
    }

    100% {
        transform: scaleY(0);
    }
}

@keyframes openFun {
    0% {
        transform: scaleY(0);
    }

    100% {
        transform: scaleY(1);
    }
}

@-webkit-keyframes openFun {
    0% {
        transform: scaleY(0);
    }

    100% {
        transform: scaleY(1);
    }
}

#share_transfer .options-err-info{
    position: absolute;
    left: calc(50% + 250px);
    top:calc(50% + 40px);
    display: none;
}

#share_transfer .options-err-info.fadeErr {
    animation: fadeErr 3s 1;
    animation-fill-mode: forwards;
    -webkit-animation: fadeErr 3s 1;
    -webkit-animation-fill-mode: forwards;
}

@keyframes fadeErr {
    from {
        opacity: 1;
    }

    to {
        opacity: 0;
    }
}

@-webkit-keyframes fadeErr {
    from {
        opacity: 1;
    }

    to {
        opacity: 0;
    }
}
</style>


// WEBPACK FOOTER //
// src/components/share_transfer.vue